import { Link } from "react-router-dom";
import { formatDate, formatViews } from "@/lib/videos";
import type { VideoItem } from "@/mocks/videos";

interface HotRankListProps {
  videos: VideoItem[];
}

export default function HotRankList({ videos }: HotRankListProps) {
  return (
    <ol className="space-y-1">
      {videos.map((video, index) => (
        <li key={video.id}>
          <Link
            to={`/detail/${video.id}`}
            className="group flex items-center gap-3 rounded-md px-2 py-2.5 transition-colors hover:bg-background-100"
          >
            <span
              className={`flex h-6 w-6 shrink-0 items-center justify-center rounded font-label text-xs font-semibold ${
                index === 0
                  ? "bg-accent-500 text-primary-950"
                  : index < 3
                    ? "bg-primary-100 text-primary-700"
                    : "bg-background-200 text-foreground-600"
              }`}
            >
              {String(index + 1).padStart(2, "0")}
            </span>
            <span className="h-12 w-20 shrink-0 overflow-hidden rounded bg-secondary-200">
              <img
                src={video.cover}
                alt={`${video.title} 缩略图`}
                title={video.title}
                className="h-full w-full object-cover object-top"
              />
            </span>
            <span className="min-w-0 flex-1">
              <span className="block truncate text-[13px] font-medium text-foreground-900 transition-colors group-hover:text-primary-700">
                {video.title}
              </span>
              <span className="mt-1 block font-label text-[11px] tracking-wide text-foreground-500">
                {formatDate(video.uploadedAt)} · {formatViews(video.views)} 次观看
              </span>
            </span>
          </Link>
        </li>
      ))}
    </ol>
  );
}